import React, { useCallback } from 'react';
import { useRouteMatch } from 'react-router-dom';

import { Box, Text, Stack, RadioCard } from 'src/components/matchbox';
import { Heading } from 'src/components/text';
import { useAlertForm } from '../useAlertForm';

export default function Data() {
  const {
    state: {
      measurementData: { measurementType }
    },
    dispatch
  } = useAlertForm();

  const isEditingAlert = useRouteMatch('/alerts/new/edit/:alertId');

  const handleMeasurementTypeChange = useCallback(
    (e) => {
      dispatch({ type: 'UPDATE_MEASUREMENT_DATA', data: { measurementType: e.target.id } });
    },
    [dispatch]
  );

  return (
    <Stack>
      <Heading as="h4">Data Measurement</Heading>
      <Box>
        <Text as="span">
          Monitor a metric by its total value or by a specific property. Properties include
          Recipient Domain, Sending IP, IP Pool, Campaign (ID), Mailbox Provider, Mailbox Provider
          Region, Template, Sending Domain, and Subaccount.
        </Text>
      </Box>

      <Box>
        <RadioCard.Group orientation="horizontal" label="Measurement Type">
          <RadioCard
            label="By Full Value"
            id="by-value"
            checked={measurementType === 'by-value'}
            name="type"
            onChange={handleMeasurementTypeChange}
          >
            Receive alerts for the
          </RadioCard>
          <RadioCard
            label="By Property Breakdown"
            id="by-breakdown"
            checked={measurementType === 'by-breakdown'}
            name="type"
            onChange={handleMeasurementTypeChange}
            disabled={isEditingAlert}
          >
            Alerts are monitored by
          </RadioCard>
        </RadioCard.Group>
      </Box>
    </Stack>
  );
}
